import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const blacklistRepository = createRepository({
  path: 'blacklist-kmm',
  restApi,
  queryTransform: {
    cpfcnpj: query.likeDigits('cpfcnpj'),
    createdAt: query.gte('createdAt'),
    ...paginate
  }
})

blacklistRepository.desbloquear = (id, data) => {
  return restApi.post(`blacklist-kmm/${id}/desbloqueio/`, data)
}

blacklistRepository.bloquear = (id, data) => {
  return restApi.post(`blacklist-kmm/${id}/bloqueio/`, data)
}

blacklistRepository.getHistorico = id => {
  return restApi.get(`blacklist-kmm/${id}/historico`)
}

export default blacklistRepository
